import React from "react";
import "./ReviewComponent.css";
import clientReview1 from "../../images/client_reviews_img_1.png"
import clientReview2 from "../../images/client_reviews_img_2.png"
import clientReview3 from "../../images/client_reviews_img_3.png"
import clientReview4 from "../../images/client_reviews_img_4.png"
import clientReview5 from "../../images/client_reviews_img_5.png"
import clientReview6 from "../../images/client_reviews_img_6.png"
import clientReview7 from "../../images/client_reviews_img_7.png"
import clientReview8 from "../../images/client_reviews_img_8.png"
import clientReview9 from "../../images/client_reviews_img_9.png"
import clientReview10 from "../../images/client_reviews_img_10.png"
import clientReview11 from "../../images/client_reviews_img_11.png"
import clientReview12 from "../../images/client_reviews_img_12.png"

const ReviewComponent2 = () => {
  return (
    <section className="client_review_wrapper">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="classes_workshop_title_outer m-auto text-center">
              <div className="smal_title smal_mid">
                <h5>Clients Review</h5>
              </div>
              <div className="classes_workshop_title">
                <h2>
                  What Clients Say
                  <span>About Us</span>
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-4">
            <div className="client_review_box">
              <div className="client_review_content">
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley of type and scrambled{" "}
                </p>
              </div>
              <div className="client_review_bottom_part">
                <div className="client_img">
                  <img
                    src={clientReview1}
                    alt="client_img"
                  />
                </div>
                <div className="client_title">
                  <h4>Jasmine Hanna</h4>
                  <p>Business man, Clients</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="client_review_box">
              <div className="client_review_content">
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley of type and scrambled{" "}
                </p>
              </div>
              <div className="client_review_bottom_part">
                <div className="client_img">
                  <img
                    src={clientReview2}
                    alt="client_img"
                  />
                </div>
                <div className="client_title">
                  <h4>Eleanor Pena</h4>
                  <p>Business man</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="client_review_box">
              <div className="client_review_content">
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley of type and scrambled{" "}
                </p>
              </div>
              <div className="client_review_bottom_part">
                <div className="client_img">
                  <img
                    src={clientReview3}
                    alt="client_img"
                  />
                </div>
                <div className="client_title">
                  <h4>Meghan Mae</h4>
                  <p>Manager</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-4">
            <div className="client_review_box">
              <div className="client_review_content">
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley of type and scrambled{" "}
                </p>
              </div>
              <div className="client_review_bottom_part">
                <div className="client_img">
                  <img
                    src={clientReview4}
                    alt="client_img"
                  />
                </div>
                <div className="client_title">
                  <h4>Simon Sais</h4>
                  <p>Dentist</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="client_review_box">
              <div className="client_review_content">
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley of type and scrambled{" "}
                </p>
              </div>
              <div className="client_review_bottom_part">
                <div className="client_img">
                  <img
                    src={clientReview5}
                    alt="client_img"
                  />
                </div>
                <div className="client_title">
                  <h4>Lynne Gwistic</h4>
                  <p>School Clerk</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="client_review_box">
              <div className="client_review_content">
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley of type and scrambled{" "}
                </p>
              </div>
              <div className="client_review_bottom_part">
                <div className="client_img">
                  <img
                    src={clientReview6}
                    alt="client_img"
                  />
                </div>
                <div className="client_title">
                  <h4>Isabelle Ringing Mae</h4>
                  <p>Web Developer</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-4">
            <div className="client_review_box">
              <div className="client_review_content">
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley of type and scrambled{" "}
                </p>
              </div>
              <div className="client_review_bottom_part">
                <div className="client_img">
                  <img
                    src={clientReview7}
                    alt="client_img"
                  />
                </div>
                <div className="client_title">
                  <h4>Constance Noring</h4>
                  <p>Business Woman</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="client_review_box">
              <div className="client_review_content">
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley of type and scrambled{" "}
                </p>
              </div>
              <div className="client_review_bottom_part">
                <div className="client_img">
                  <img
                    src={clientReview8}
                    alt="client_img"
                  />
                </div>
                <div className="client_title">
                  <h4>Frank N. Stein</h4>
                  <p>MBBS Student</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="client_review_box">
              <div className="client_review_content">
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley of type and scrambled{" "}
                </p>
              </div>
              <div className="client_review_bottom_part">
                <div className="client_img">
                  <img
                    src={clientReview9}
                    alt="client_img"
                  />
                </div>
                <div className="client_title">
                  <h4>Peg Legge</h4>
                  <p>Manager, Clients</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-4">
            <div className="client_review_box">
              <div className="client_review_content">
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley of type and scrambled{" "}
                </p>
              </div>
              <div className="client_review_bottom_part">
                <div className="client_img">
                  <img
                    src={clientReview10}
                    alt="client_img"
                  />
                </div>
                <div className="client_title">
                  <h4>Patty O’Furniture</h4>
                  <p>Business man</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="client_review_box">
              <div className="client_review_content">
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley of type and scrambled{" "}
                </p>
              </div>
              <div className="client_review_bottom_part">
                <div className="client_img">
                  <img
                    src={clientReview11}
                    alt="client_img"
                  />
                </div>
                <div className="client_title">
                  <h4>Amber Mody</h4>
                  <p>School Teacher</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="client_review_box">
              <div className="client_review_content">
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley of type and scrambled{" "}
                </p>
              </div>
              <div className="client_review_bottom_part">
                <div className="client_img">
                  <img
                   src={clientReview12}
                    alt="client_img"
                  />
                </div>
                <div className="client_title">
                  <h4>Jack Aranda</h4>
                  <p>Body Builder</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReviewComponent2;
